import React, { useState } from "react";
import axios from "../../../axios"

const ThreeDot_Post_Popup = ({
  setPostThreedot,
  comment_id,
  post_id,
  user_id,
  setIsInProgress,
  setIsCommented,
  isInProgress,
  commentData,
  isCommented,
  setFilter,
  filter,
  setComments,
  setCurrentCommentNumber,
  currentCommentNumber,
  setClickEditComment,
  setDeleteClicked
}) => {
  const [delet1, setDelet1] = useState(false);

  return (
    <>
      <div style={{
        zIndex: 10,
        position: "absolute",
        right: "40px",
      }} className=" p-2 PostPopupBox ">
        <button
          className="Post_popup_btn"
          onClick={() => {
            setPostThreedot(false);
            setClickEditComment((prev) => !prev)
          }}
        >
          <img src="/images/EditIcon.svg" style={{ width: "30px", height: "30px" }} alt="Edit"></img>
          Edit
        </button>
        <button className="Post_popup_btn" onClick={() => setDeleteClicked((prev) => !prev)}>
          <img src="/images/DeleteIcon.svg" style={{ width: "30px", height: "30px" }} alt="Del"></img> Delete
        </button>
      </div>
    </>
  );
};

export default ThreeDot_Post_Popup;
